module.exports = __webpack_public_path__ + "static/img/icon6.e50e0759.png";